<div class="flex flex-col items-center justify-center gap-8 w-full pb-8">
  @for (activity of activities(); track activity.id; let i = $index) {
    <div
      class="flex items-center justify-between border rounded-lg p-4 w-full"
      [class.completed]="activity.isCompleted"
      [class.opacity-60]="isActivityBlocked(activity)"
    >
      <div class="flex items-center gap-12 min-w-0">
        <div
          class="flex items-center justify-center shrink-0 p-3 w-10 h-10 rounded-full border"
          [class.bg-green-600]="activity.isCompleted"
          [class.bg-yellow-400]="activity.isDraft"
          [class.text-white]="activity.isCompleted"
        >
          @if (activity.isCompleted) {
            <i class="pi pi-check"></i>
          } @else if (activity.isDraft) {
            <i class="pi pi-pen-to-square"></i>
          } @else {
            <span class="font-semibold">{{ i + 1 }}</span>
          }
        </div>

        <div class="flex flex-col items-start text-left">
          <p class="font-semibold">{{ activity.title }}</p>
          <p>{{ activity.description }}</p>
          @if (isActivityBlocked(activity)) {
            <p class="text-color-secondary font-semibold">
              {{ 'pre-employment.list-activities.blocked.label' | translate }}
            </p>
          }
          @if (getDeadline(activity)) {
            <p class="text-primary font-bold">
              {{ 'pre-employment.list-activities.dealine-at' | translate }}
              {{ getDeadline(activity) | date: 'dd/MM/yyyy' : 'UTC' }}
            </p>
          }
        </div>
      </div>
      <div>
        <p-button
          [label]="getButtonLabel(activity)"
          [disabled]="isActivityBlocked(activity)"
          (onClick)="onActivityClick(activity)"
        />
      </div>
    </div>
  }
</div>
